import styled, { keyframes } from 'styled-components'
import { PageTitleStandard } from './Text.style'
import { PageActionButton } from './Button.style'

const DRAWER_MIN_HEIGHT = 400
const DRAWER_HEADER_HEIGHT = 60
const DRAWER_FOOTER_HEIGHT = 76
const BACKGROUND_COLOR_ENABLED = false

const smoothEntering = keyframes`
    from {
        opacity: 0;
        transform: translateY(50px);
    }
    to {
        opacity: 1;
        transform: translateY(0px);
    }
`

export const DrawerContainer = styled.div`
    position: fixed;
    z-index: 101;
    background-color: #FFF;
    top: unset;
    bottom: 0;
    left: 0;
    /* min-height: ${DRAWER_MIN_HEIGHT}px; */
    max-height: ${`calc(100vh - 180px)`};
    width: 100vw;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 0px 24px;
    animation: ${smoothEntering} 0.7s;
`

export const DrawerBackground = styled.div`
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.8);
    animation: ${smoothEntering} 0.5s;
`

export const DrawerTitleContainer = styled.div`
    background-color: ${BACKGROUND_COLOR_ENABLED ? `lightblue` : `transparent`};
    position: relative;
    width: 100%;
    min-height: ${DRAWER_HEADER_HEIGHT}px;
    height: ${DRAWER_HEADER_HEIGHT}px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

export const DrawerTitle = styled(PageTitleStandard)`
    align-self: flex-start;

    &.light-title {
        font-family: "Unipol-Medium"
    }
`

export const DrawerMainContent = styled.div`
    background-color: ${BACKGROUND_COLOR_ENABLED ? `yellowgreen` : `transparent`};
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow-y: hidden;
`

export const DrawerFooterContainer = styled.div`
    background-color: ${BACKGROUND_COLOR_ENABLED ? `orangered` : `transparent`};
    position: relative;
    width: 100%;
    min-height: ${DRAWER_FOOTER_HEIGHT}px;
    height: ${DRAWER_FOOTER_HEIGHT}px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

export const DrawerActionButton = styled(PageActionButton)`
`
